<style>

/* .code{
  display: grid;
  grid-template-columns: 40px 40px 40px 40px 40px 40px;
  text-align: center;
  justify-content: space-evenly;
  color: white;
}
.code1{ grid-column: 1; }
.code2{ grid-column: 2; }
.code3{ grid-column: 3; }
.code4{ grid-column: 4; }
.code5{ grid-column: 5; }
.code6{ grid-column: 6; }
.outline{
  border: 1px white solid;
  height: 43px;
  font-size: 35px;
  text-align: center;
  margin: 1px;
} */

.code{
  text-align: center;
}

input[type="text"] {
  background-color: inherit;
  border: 1px white solid;
  height: auto;
  font-size: 75px;
  width: 302px;
  text-align: center;
  border-radius: 0;
  color: white;
  font-family: monospace;
}
</style>

<div class="code">
  <input id="code" pattern="[0-9]*" type="text" bind:value="{code}" on:keyup="{checkPaste}" autocomplete="off">
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let verifyCode = "";

let lastCode = "";
let code = "";

let interval = null;

import { onMount, onDestroy } from "svelte";
onMount(async () => {
  if (navigator.userAgent.match(/(iPhone|iPod|iPad)/)) {
    interval = setInterval(checkPaste, 500);
  }
});


onDestroy(async () => {
  clearInterval(interval);
});


$:{
  if (verifyCode) {
    parseCode();
  }
  if (verifyCode == "") {
    clearCode();
  }
}


function parseCode() {
  // console.log("verifyCode:", verifyCode);
  // console.log("verifyCode.length:", verifyCode.length);
  
  if (verifyCode.length == 6) {
    code = verifyCode;
    lastCode = verifyCode;
    dispatch("check");
  } else if (verifyCode.length > 6) {
    dispatch("clear");
  }
}


function clearCode() {
  if (verifyCode == "") {
    code = "";
  }
}


function checkPaste(e) {
  
  if (code != lastCode) {
    
    lastCode = code;
    
    if (code.length == 6) {
      verifyCode = code;
    } else if (code.length > 6) {
      code = "";
      lastCode = "";
      verifyCode = "";
    }
  }    
}

</script>